import { render, staticRenderFns } from "./EditarCartorio.vue?vue&type=template&id=3aff7e74&scoped=true"
import script from "./EditarCartorio.vue?vue&type=script&lang=js"
export * from "./EditarCartorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff7e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aff7e74')) {
      api.createRecord('3aff7e74', component.options)
    } else {
      api.reload('3aff7e74', component.options)
    }
    module.hot.accept("./EditarCartorio.vue?vue&type=template&id=3aff7e74&scoped=true", function () {
      api.rerender('3aff7e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditarCartorio.vue"
export default component.exports